// filepath: /home/vosvald/sites/wishmaker-user-area-react/src/pages/mobile-signature/index.js
import MobileSignaturePage from './mobile-signature';
export default MobileSignaturePage;

